(function() {
    'use strict';
    
a3_cabin_reports.factory('SpecialMealIssueFactory', SpecialMealIssueFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SpecialMealIssueFactory
    * @description 
    *   Manage Report's SpecialMealIssues.
    * @ngInject
    */
function SpecialMealIssueFactory(GenericModalFactory) {

        /**
         * Initialiaze SpecialMealIssue object 
         * @memberof SpecialMealIssueFactory
         */
		function SpecialMealIssue() {
			this.Id = null;
			this.Name = null;
			this.Phone = null;
			this.Email = null;
			this.Source = null;
			this.MealType = null;
			this.ReturnDate = null;
			this.Remarks = null;
		}
		
		var service = {
			createNew : createNew,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			deleteFromList : deleteFromList
		}
			
        /**
         * Create new SpecialMealIssue object 
         * @memberof SpecialMealIssueFactory
         */
		function createNew() {
			return GenericModalFactory.createNew(SpecialMealIssue)
		};

        /**
         * Extend given SpecialMealIssue object 
         * @memberof SpecialMealIssueFactory
         * @param {object} obj The SpecialMealIssue object that will be extended
         * @returns {object} SpecialMealIssue
         */  
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,SpecialMealIssue)
		}
    
        /**
         * Delete SpecialMealIssue object from given list
         * @memberof SpecialMealIssueFactory
         * @param {object} obj The SpecialMealIssue object that will be deleted
         * @returns {array} SpecialMealIssues
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}
        /**
         * Extend given SpecialMealIssue object List 
         * @memberof SpecialMealIssueFactory
         * @param {object} obj The SpecialMealIssue object that will be extended
         * @returns {array} SpecialMealIssues
         */  
		function fromObjectList(objList) {
			return GenericModalFactory.fromObjectList(objList,SpecialMealIssue)
		}

		return service;
	}

})();
